import { AxiosError } from 'axios'

/**
 * Извлекает сообщение об ошибке из axios ошибки.
 * Приоритет: response.data.message > response.data.error > error.message
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    const axiosError = error as AxiosError<{ message?: string; error?: string }>
    
    // Если это axios ошибка с response
    if (axiosError.response?.data) {
      const data = axiosError.response.data
      
      // Приоритет: message из ответа сервера
      if (data.message) {
        return data.message
      }
      
      // Если есть error поле
      if (data.error) {
        return data.error
      }
    }
    
    // Fallback на стандартное сообщение ошибки
    return error.message
  }
  
  // Если это не Error объект
  return String(error)
}

/** Технические axios/сетевые тексты — не показывать пользователю как есть. */
export function isTechnicalErrorMessage(message: string): boolean {
  return (
    /^Network Error$/i.test(message) ||
    /^Request failed with status code \d+$/i.test(message) ||
    /^timeout of \d+ms exceeded$/i.test(message)
  )
}

/** Сообщение для Alert: серверное оставляем, техническое заменяем на i18n fallback. */
export function displayErrorMessage(message: string | null | undefined, fallback: string): string {
  if (!message || isTechnicalErrorMessage(message)) {
    return fallback
  }
  return message
}
